var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetting2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.343 15.5855C26.9682 16.4821 27.4081 17.5176 27.6073 18.6363H30V21.3637H27.6073C27.4081 22.4824 26.9682 23.5178 26.343 24.4145L28.0353 26.1068L26.1068 28.0353L24.4145 26.343C23.5178 26.9682 22.4824 27.4081 21.3637 27.6073V30H18.6363V27.6073C17.5176 27.4081 16.4821 26.9682 15.5855 26.343L13.8931 28.0353L11.9647 26.1068L13.657 24.4145C13.0318 23.5178 12.5919 22.4824 12.3927 21.3637H10V18.6363H12.3927C12.5919 17.5176 13.0318 16.4821 13.657 15.5855L11.9647 13.8931L13.8931 11.9647L15.5855 13.657C16.4821 13.0318 17.5176 12.5919 18.6363 12.3927V10H21.3637V12.3927C22.4824 12.5919 23.5178 13.0318 24.4145 13.657L26.1068 11.9647L28.0353 13.8931L26.343 15.5855Z",
    stroke: "#22D758",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C21.6568 23 23 21.6568 23 20C23 18.3432 21.6568 17 20 17C18.3432 17 17 18.3432 17 20C17 21.6568 18.3432 23 20 23Z",
    stroke: "#22D758",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting2.cf03fca3.svg";
export { ForwardRef as ReactComponent };